module.exports = __webpack_public_path__ + "src/img/driver.e459bc5f.svg";